<template>
  <jet-authentication-card>
    <template #logo>
      <jet-authentication-card-logo />
      <AppHead title="Complete Account Setup" />
    </template>

    <jet-validation-errors class="mb-4" />

    <form class="py-3" @submit.prevent="submit">
      <div v-if="!needs_info" class="mb-3">
        <p>To complete your account creation, please create a password to use the application.</p>
        <input type="text" class="form-control" disabled="disabled" name="email" autocomplete="username" v-model="form.email"/>
      </div>
      <div v-else>
        <p>To complete your account creation, please complete your profile and create a password to use the application.</p>
        <div class="form-group">
          <jet-label for="first_name" value="First Name" />
          <jet-input id="first_name" type="text" class="form-control" v-model="form.first_name" required />
        </div>
        <div class="form-group">
          <jet-label for="last_name" value="Last Name" />
          <jet-input id="last_name" type="text" class="form-control" v-model="form.last_name" required />
        </div>
        <div class="form-group" v-if="!user.email || user.email.length == 0">
          <jet-label for="email" value="Email" />
          <jet-input id="email" type="email" class="form-control" v-model="form.email" autocomplete="username" required />
        </div>
        <div v-else>
          <input type="hidden" v-model="form.email"/>
        </div>
        <div class="form-group" v-if="!user.phone_number || user.phone_number.length == 0">
          <jet-label for="phone" value="Phone" />
          <jet-input id="phone" type="text" class="form-control" v-model="form.phone_number" required />
        </div>
        <div class="form-group" v-if="!user.mtd_info_dob || user.mtd_info_dob.length == 0">
          <jet-label for="mtd_info_dob" value="Date of Birth" />
          <Calendar v-model="form.mtd_info_dob"  view="year" class="w-100" id="mtd_info_dob" :showIcon="true" :selectOtherMonths="true"/>
        </div>
        <div class="form-group" v-if="!user.mtd_info_ssn_last4 || user.mtd_info_ssn_last4.length != 4">
          <jet-label for="mtd_info_ssn_last4" value="Last 4 of SSN" />
          <jet-input id="mtd_info_ssn_last4" type="text" class="form-control" v-model="form.mtd_info_ssn_last4" required />
        </div>
        <div class="form-group" v-if="!user.mtd_info_ein || user.mtd_info_ein.length == 0">
          <jet-label for="mtd_info_ein" value="EIN (tax ID)" />
          <jet-input id="mtd_info_ein" type="text" class="form-control" v-model="form.mtd_info_ein" required />
        </div>
      </div>
      <div class="form-group">
        <jet-label for="password" value="Password" />
        <jet-input id="password" type="password" class="form-control" v-model="form.password" required autocomplete="new-password" />
      </div>

      <div class="form-group">
        <jet-label for="password_confirmation" value="Confirm Password" />
        <jet-input id="password_confirmation" type="password" class="form-control" v-model="form.password_confirmation" required autocomplete="new-password" />
      </div>

      <div class="mt-4" v-if="$page.props.jetstream.hasTermsAndPrivacyPolicyFeature">
        <jet-label for="terms">
          <div class="flex items-center">
            <jet-checkbox name="terms" id="terms" v-model:checked="form.terms" />

            <div class="ml-2">
              I agree to the <a target="_blank" :href="route('terms.show')" class="underline text-sm text-gray-600 hover:text-gray-900">Terms of Service</a> and <a target="_blank" :href="route('policy.show')" class="underline text-sm text-gray-600 hover:text-gray-900">Privacy Policy</a>
            </div>
          </div>
        </jet-label>
      </div>

      <div class="flex items-center justify-end mt-4">
        <jet-button type="submit" :disabled="form.processing">Complete Setup</jet-button>
      </div>
    </form>
  </jet-authentication-card>
</template>

<script>
  import JetAuthenticationCard from '@/Jetstream/AuthenticationCard'
  import JetAuthenticationCardLogo from '@/Jetstream/AuthenticationCardLogo'
  import JetButton from '@/Jetstream/Button'
  import JetInput from '@/Jetstream/Input'
  import JetCheckbox from "@/Jetstream/Checkbox";
  import JetLabel from '@/Jetstream/Label'
  import JetValidationErrors from '@/Jetstream/ValidationErrors'

  import Calendar from 'primevue/calendar';

  export default {
    components: {
      JetAuthenticationCard,
      JetAuthenticationCardLogo,
      JetButton,
      JetInput,
      JetCheckbox,
      JetLabel,
      JetValidationErrors,
      Calendar
    },

    data() {
      return {
        form: this.$inertia.form({
          code: this.code,
          first_name: this.user.first_name,
          last_name: this.user.last_name,
          email: this.user.email,
          phone_number: this.user.phone_number,
          mtd_info_dob: this.user.mtd_info_dob,
          mtd_info_ssn_last4: this.user.mtd_info_ssn_last4,
          mtd_info_ein: this.user.mtd_info_ein,
          password: '',
          password_confirmation: '',
          terms: false,
        })
      }
    },

    props: {
    user: Object,
    code: String,
    needs_info: Boolean
    },
    methods: {
      submit() {
        this.form.post(this.route('mtd.setup'), {
          onFinish: () => this.form.reset('password', 'password_confirmation'),
        })
      }
    }
  }
</script>
